<!-- Ported from the Polaris kit: src/components/ui/input-group/InputGroupText.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <span
    :class="
      cn(
        `text-polaris-muted-foreground flex items-center gap-2 type-polaris-body [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4`,
        props.class
      )
    "
  >
    <slot />
  </span>
</template>
